import SellerShared from './seller-shared';

export {
  getServerSideProps,
} from "./seller-main";

export default SellerShared;
